import { IonButton, IonCard, IonText } from "@ionic/react";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface NoMatchProps {
    notMatchesTitle: string;
    page: "fixtures" | "results";
    selectedDate?: string;
}

const NoMatchesComponent: FC<NoMatchProps> = ({
    notMatchesTitle,
    page,
}) => {
    const { t } = useTranslation();

    // Show video and learn more for results page when user first signs up
    if (page === "results") {
        return (
            <IonCard className="no-upcoming-matches">
                <IonText>
                    <h2 style={{ marginBottom: "20px", color: "white", textTransform: 'uppercase' }}>
                        {t("general.getStartedTitle")}
                    </h2>
                </IonText>
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        marginBottom: "10px",
                    }}
                >
                    <div
                        style={{
                            padding: "56.25% 0 0 0",
                            position: "relative",
                        }}
                    >
                        <iframe
                            src="https://player.vimeo.com/video/1117068253?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&autoplay=0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                border: 0,
                            }}
                            title={t("general.getStartedTitle")}
                        ></iframe>
                    </div>
                </div>
                <IonButton
                    data-testid="learnMore"
                    expand="block"
                    className="button-width"
                    style={{ textTransform: 'uppercase' }}
                    onClick={() => {
                        window.open('https://scorzahelp.zendesk.com/hc/start', '_system');
                    }}
                >
                    {t("upgrade.upgrade.learnMore")}
                </IonButton>
            </IonCard>
        );
    }

    return (
        <IonCard className="no-upcoming-matches">
            <IonText data-testid="noEndedFixturesTxt">
                <IonText>{notMatchesTitle}</IonText>
            </IonText>
        </IonCard>
    );
};

export default NoMatchesComponent;
